import { required } from 'vuelidate/lib/validators';

export default {
  firstName: { required }
};
